import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initMetaPixel } from "./utils/metaPixel";

// The Meta Pixel loads before React mounts, matching the behavior of the
// official snippet placed in the document <head>.
try {
  initMetaPixel();
} catch (error) {
  console.warn("Meta Pixel no pudo inicializarse:", error);
}
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-272" data-mp="2f9z1bfr3ximf" />);
}